import React from 'react';
import $ from 'jquery';
import cal from "../Projects pics/calci.PNG";
import facedetect from "../Projects pics/facedetect.PNG";
import mapbox from "../Projects pics/mapbox.PNG";
import tictactoe from "../Projects pics/tictactoe.PNG";
import todo from "../Projects pics/todo.PNG";
const Projects=()=>{
    function mouseover(props) {
    let p = document.getElementsByClassName("background")[props];
    let q = document.getElementsByClassName('op')[props];
    // p.style.transition="all 5s ease-in";
    // console.log({props});
    p.style.display = "flex";
    q.style.display = "flex";

  }
  function mouseleave(props) {
    let p = document.getElementsByClassName("background")[props];
    let q = document.getElementsByClassName('op')[props];

    p.style.display = "none";
    q.style.display = "none";


  }
   function call() {
    //   let y=document.querySelector('.whole');
    if (document.querySelector('#load').style.display == "none") {
      $('html').css('overflow-y', 'auto');
      console.log('nio');
    }
  }
    return(
        <>
         <div className="projects container-fluid" id="third"  onMouseEnter={() => call()}>
                <p id="proj" data-aos="fade-up"
     data-aos-duration="3000">Projects</p>
                <div class="row">
                  <div class="col-lg" data-aos="zoom-in">
                  <div class="profile-box">
                  <div class="img-area">
                                <img src={cal} alt=""/>
                            </div>
                            <div class="img-text">
                            JS calculator
      <a href="https://calculator-14.herokuapp.com/" target="blank"><button >Visit Project</button></a>
                            </div>
                    </div>
                  </div>
                  <div class="col-lg" data-aos="zoom-in">
                  <div class="profile-box">
                  <div class="img-area">
                                <img src={facedetect} alt=""/>
                            </div>
                            <div class="img-text">
                            Face Detection App
      <a href="https://github.com/Avishake007/Face-eye-detector" target="blank"><button >Visit Project</button></a>
                            </div>
                    </div>
                    </div>
                  <div class="col-lg" data-aos="zoom-in">
                  <div class="profile-box">
                  <div class="img-area">
                                <img src={mapbox} alt=""/>
                            </div>
                            <div class="img-text">
                            Coronavirus Map
      <a href="https://corona-map14.herokuapp.com/" target="blank"><button >Visit Project</button></a>
                            </div>
                    </div>
                    </div>
                  <div class="col-lg" data-aos="zoom-in">
                  <div class="profile-box">
                  <div class="img-area">
                                <img src={tictactoe} alt=""/>
                            </div>
                            <div class="img-text">
                            Tictactoe using Minimax
      <a href="https://tic-tac14.herokuapp.com/" target="blank"><button >Visit Project</button></a>
                            </div>
                    </div>
                    
                    </div>
                </div>
                <div class="row">
                  <div class="col-lg" data-aos="zoom-in" >
                  <div class="profile-box">
                  <div class="img-area">
                                <img src={todo} alt=""/>
                            </div>
                            <div class="img-text">
                            Todo List
      <a href="https://avishake007.github.io/TodDolist/" target="blank"><button >Visit Project</button></a>
                            </div>
                    </div>
                    </div>
                </div>
              </div>
        </>
    )
}
export default Projects;